export default {
  "HitPaw Online Audio Converter": "HitPaw ऑनलाइन ऑडियो कन्वर्टर",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "ऑडियो को मुफ़्त MP3, AAC, FLAC, WMA आदि फॉर्मेट में बदलें।",
  'HitPaw Online Image Converter': 'HitPaw ऑनलाइन छवि कन्वर्टर',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': 'छवियों को मुफ़्त JPG, PNG, BMP, TIFF आदि फॉर्मेट में बदलें।',
  'HitPaw Online Video Converter': 'HitPaw ऑनलाइन वीडियो कंवर्टर',
  'Convert videos to any formats as your requirements.': 'अपनी आवश्यकतानुसार किसी भी फॉर्मेट में वीडियो बदलें।',
  'Add More Files': 'और अधिक फाइलें जोड़ें',
  'Convert to': 'बदलें',
  'Ready': 'तैयार',
  'Converting': 'बदला जा रहा है',
  'Video': 'वीडियो',
  'Audio': 'ऑडियो',
  'Image': 'छवि',
  'Retry': 'दोबारा कोशिश करें',
  'Download All': 'सभी डाउनलोड करें',
  'Download Desktop': 'डेस्कटॉप डाउनलोड करें',
  'Continue Editing': 'संपादन जारी रखें',
  'Convert': 'बदलें',
  'Cut': 'काटें',
  'Speed': 'गति',
  'Crop & Rotate': 'क्रॉप और रोटेट करें',
  'Resize': 'आकार बदलें',
  'Extract': 'निकालें',
  'Add Music': 'म्यूज़िक डालें',
  'Subtitles': 'उपशीर्षक',
  'Merge': 'मिलाएं',
  'Watermark Remover': 'वॉटरमार्क रिमूवर',
  'Add Watermark': 'वॉटरमार्क जोड़ें',
  'Please select a file to use': '{{work}} प्रयोग करने के लिए कृपया एक फाइल चुनें',
  'Batch Processing': 'Batch Processing',
};
